import { render, staticRenderFns } from "./Abonents.vue?vue&type=template&id=ea9f008e&"
import script from "./Abonents.vue?vue&type=script&lang=js&"
export * from "./Abonents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports